import {inject, Injectable} from '@angular/core';
import {SpringRestService} from '@aiknow-srl/aik-angular-sdk';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService implements CanActivate {


  private be = inject(SpringRestService);


  /**
   * CanActivate Route method used to validate the access to a specific route
   * @param route the route activated
   * @param state thr Router State Snapshot
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.be.isUserLoggedIn();
  }
}
